import * as React from "react";
import { SvgIcon } from "@montana/shared/svg-icon";
import { Link } from "@montana/shared/link";

export interface IProgressStep {
    title: string;
    link: string;
}

export interface IProgressbar {
    currentIndex?: number;
    allowNavigationBack?: boolean;
    allowNavigationForward?: boolean;
    steps: IProgressStep[];
}

export const ProgressBar: React.FC<IProgressbar> = (props: IProgressbar): JSX.Element => {
    const {
        allowNavigationBack = true,
        allowNavigationForward = false,
        currentIndex,
        steps
    } = props;

    const allowLink = (index: number) => {
        if (typeof currentIndex === 'undefined' || index === currentIndex) return true;
        if (index < currentIndex && allowNavigationBack) return true;
        if (index > currentIndex && allowNavigationForward) return true;
        return false;
    }

    const generateProgressStep = (step: IProgressStep, index: number) => (
        <div className={`progress-bar__step ${currentIndex != null && currentIndex < index ? "progress-bar__step--inactive" : ""}`}>

            <div className={`progress-bar__step-count ${currentIndex === index ? "progress-bar__step-count--active" : ""} ${currentIndex != null && currentIndex > index ? "progress-bar__step-count--checked" : ""}`}>

                <div className="progress-bar__step-count-content">
                    <span>{index + 1}</span>
                </div>

                <div className="progress-bar__step-count-content--was-active">
                    <SvgIcon iconName="checkmark" />
                </div>

                <div className="progress-bar__step-count-content--active">
                    <span>{index + 1}</span>
                </div>
            </div>

            <div className="progress-bar__step-text">
                {step.title}
            </div>
        </div>
    );

    return (
        <div className="progress-bar">
            {steps.map((step, index) =>
                <React.Fragment key={index}>
                    {index > 0 &&
                    <span className={`progress-bar__step-spacer ${currentIndex != null && currentIndex < index ? "progress-bar__step-spacer--inactive" : ""}`}></span>
                    }
                    {allowLink(index) ? (
                        <Link to={step.link}>
                            {generateProgressStep(step, index)}
                        </Link>) : generateProgressStep(step, index)}
                </React.Fragment>
            )}
        </div>
    );
};
